module.exports = __webpack_public_path__ + "static/media/folder_theme2.fe8a21d7.svg";